$(document).ready(function(){
  loadMore();
});

$(window).on('resize', function(){
  loadMore();
});
function loadMore(){
  if ($(window).width() < 551) {
    $(".load-more_btn").show();
      $(".product-grid-container li.grid__item").each(function(index, value){
        if(index > 3){
          $(this).hide();
        }
      });
    if ($(".product-grid-container li.grid__item").length < 4) {
        $(".load-more_btn").hide();
    }
  }else{
    $(".load-more_btn").hide();
    $(".product-grid-container li.grid__item").show();
  }
}

$(document).on('click', '.load-more_btn', function (e) {
  e.preventDefault();
  $(".product-grid-container .grid__item:hidden").each(function(index, value){
  if(index < 4){
    $(this).show();
  }
});
    
    //$(".product-grid-container .grid__item:hidden").slice(0, 4).show();
    if ($(".product-grid-container .grid__item:hidden").length == 0) {
        $(".load-more_btn").hide();
    }
   $('.product_card_img_slider').slick('refresh');
});